/*
 * Password policy — ported from the legacy PasswordStrengthIndicator
 * (≥8 chars, at least 1 digit, at least 1 special char). Pure & testable.
 */
export function passwordChecks(pw) {
  const v = pw || ''
  return {
    length: v.length >= 8,
    digit: /\d/.test(v),
    special: /[^A-Za-z0-9]/.test(v),
  }
}

export function isValidPassword(pw) {
  const c = passwordChecks(pw)
  return c.length && c.digit && c.special
}

// 0..3 score for the strength meter.
export function passwordScore(pw) {
  const c = passwordChecks(pw)
  return [c.length, c.digit, c.special].filter(Boolean).length
}
